
import { useParams } from "react-router-dom"
import { useState, useEffect } from 'react'
import { Box, Button, Card, MenuItem, TextField, Typography } from "@mui/material"
import { Container } from "@mui/material";
import Loading from "../../load/loading";
import api from "../../services/api";
import { useSelector } from 'react-redux';
import Date from "../../utils/date";
import ResponseReclamacao from "./responseReclamacao";
import HeaderSession from "../../utils/headerSession";
import TextoFormatado from "../../utils/textoFormatado";
import InfoFieldGroup from "../../utils/InfoField/InfoFieldGroup";
import ButtonLeft from "../../utils/buttonLeft";
import HeaderGestorConfigs from "../../utils/headerGestorConfigs";


export default function ViewReclamacao() {
    let { id } = useParams();
    const [reclamacao, setReclamacao] = useState('');
    const user = useSelector(state => state.account.user);
    const [update, setUpdate] = useState(false);
    const [estado, setEstado] = useState("");

    useEffect(() => {
        api.get(`/reclamacao/${id}`)
            .then(response => {
                // console.log(response)
                setReclamacao(response.data.reclamacao);
            }).catch(error => {
                // console.log(error)
                // if (error.response.status === 500) {
                //     setMessageError('Reclamação não encontrada')
                //     window.setTimeout(() => {
                //         navigate(-1)
                //     }, 1000);
                // }
            })
    }, [id, update])


    const handleChangeStatus = () => {
        api.patch("/reclamacao/change-status", {
            id,
            status: estado,
            userId: user?._id
        })
            .then(() => {
                // setSuccess("Estado actualizado!");
                // setRefreshPage((prev) => !prev);
                setEstado("");
            })
            .catch((err) => {
                // setError(err?.response?.data?.message);
            })
            // .finally(() => setEstado(false));
    };


    const estados = ['DGA SE', 'DGS SA', 'DCITMS', 'DADG', 'DASG', 'DCQMTS', 'DFTEC', 'DLIF', 'DMTS'];

    return (
        reclamacao
            ?
            <Container style={{ marginBottom: 20 }}>
                <HeaderSession title={'GESTÃO DE RECLAMAÇÃO'} />
                <Card style={{ padding: 20, marginBottom: 10, position: 'relative' }}>

                    <InfoFieldGroup

                        fields={
                            [
                                { label: 'Estado', value: reclamacao?.status, editable: false, },
                                { label: 'Localização', value: reclamacao?.numero, editable: false, },
                                { label: 'Assunto', value: reclamacao?.assunto, editable: false, },
                                { label: 'Nome', value: reclamacao?.nome, editable: false, },
                                { label: 'Contacto', value: reclamacao?.tel1, editable: false, },
                                { label: 'Email', value: reclamacao?.email, editable: false, },
                                { label: 'Data', value: <Date date={reclamacao?.createdAt} />, editable: false, },
                            ]
                        } />
                    <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                        <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">
                            <strong>Exposição:</strong>
                        </Typography>
                        <TextoFormatado texto={reclamacao.descricao} />
                    </Box>
                </Card>

                {reclamacao?.anexo1 &&
                    <Card style={{ padding: 20, position: 'relative' }}>
                        <Typography variant="subtitle1" style={{ margin: 10 }}>
                            Documento anexado:
                            <br />
                            <a target="_blank" href={reclamacao?.anexo1} > anexo_1</a>
                        </Typography>
                        <embed
                            id="pdfIframe"
                            title={`PDF Viewer`}
                            src={[reclamacao?.anexo1]}
                            width="100%"
                            height="800px"
                            style={{ border: 'none' }}
                        />
                    </Card>
                }

                <Card sx={{ padding: 2 }}>
                    <HeaderGestorConfigs title='Estado da Reclamação' />
                    {/* 
                    {error && (<MessageError message={error} />)}
                    {success && <MessageSuccess message={success} />} */}

                    <TextField
                        label="Encaminhar reclamação para:"
                        select
                        size="small"
                        defaultValue={reclamacao?.status}
                        onChange={(e) => setEstado(e.target.value)}
                        fullWidth
                        // disabled
                    >
                        {estados.map((option) => (
                            <MenuItem disabled key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>

                    {estado &&
                        <ButtonLeft
                            title={'Salvar'}
                            load={false}
                            funcao={handleChangeStatus}
                        >
                            <Button
                                color="error"
                                onClick={() => { setEstado("") }}>
                                Cancelar
                            </Button>
                        </ButtonLeft>
                    }
                </Card>

                <ResponseReclamacao
                    userId={user?._id}
                    id={id}
                    respostas={reclamacao.respostas}
                    setUpdate={setUpdate}
                />

            </Container>
            :
            <Loading text={'A acarregar reclamção.'} />
    )
}